export interface ICookieService {
  get(name: string): string | null;
}

class CookieService implements ICookieService {
  get(name: string): string | null {
    const matches = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)"),
    );
    return matches ? decodeURIComponent(matches[2] || "") : null;
  }
}

export const cookieService = new CookieService();
